import React from 'react';
import { Button, Spinner } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  disabled: boolean;
  saving: boolean;
  showNext?: boolean;
  showSave: boolean;
  onBack?: () => void;
}


export default function Controls({ disabled, onBack, saving, showNext, showSave }: Props) {
  return (
    <div className="mt-4">
      {onBack && (
        <Button className="me-2" id="back_profile_step_button" variant="outline-secondary" onClick={onBack}>
          <FontAwesomeIcon className="me-2" icon={faAngleLeft} />
          Back
        </Button>
      )}
      {showNext && (
        <Button className="me-2" disabled={disabled} id="next_profile_step_button" type="submit" variant="secondary">
          <>
            Next
            <FontAwesomeIcon className="ms-2" icon={faAngleRight} />
          </>
        </Button>
      )}
      {showSave && (
        <Button disabled={disabled} id="save_profile_step_button" type="submit" variant="secondary">
          {saving && <Spinner animation="border" size="sm" />}
          Save
        </Button>
      )}
    </div>
  );
}
